






























interface ISelectItem {
  text: string;
  value: string;
}
export interface IFilterData {
  searchBy: string;
  searchPhrase: string;
}

export default {
  name: 'CopyStakeAiStreamersFilter',

  data(): any {
    return {
      searchPhrase: '',
      searchBy: 'nickname'
    };
  },
  computed: {
    searchByOptions(): ISelectItem[] {
      return [
        {
          text: 'Nickname',
          value: 'nickname'
        },
        {
          text: 'Operator User ID',
          value: 'operatorUserId'
        }
      ];
    },

    currentSearchBy(): ISelectItem {
      return this.searchByOptions.find(
        (el: ISelectItem) => el.value === this.searchBy
      );
    },

    searchPlaceholder(): string {
      return `Search by ${this.currentSearchBy?.text || '---'}`;
    },

    disableSearch(): boolean {
      const isValidSearchPhraseLength = this.searchPhrase?.length >= 3;

      return !(this.searchPhrase && isValidSearchPhraseLength);
    }
  },
  watch: {
    searchPhrase(val: string): void {
      if (val) return;

      this.handleClickSearchClearButton();
    }
  },
  methods: {
    handleClickSearchButton(): void {
      if (this.disableSearch) return;

      const filters: IFilterData = {
        searchPhrase: this.searchPhrase,
        searchBy: this.searchBy
      };

      this.$emit('update-filter', filters.searchPhrase ? filters : null);
    },

    handleClickSearchClearButton(): void {
      this.$emit('update-filter');
    }
  }
};
